const root = document.getElementById("PupsUpLeashStudio");

    document.querySelectorAll('#mainSwatches .swatch').forEach(button => {
      button.addEventListener('click', () => {
        document.querySelectorAll('#mainSwatches .swatch').forEach(b => b.classList.remove('is-active'));
        button.classList.add('is-active');
        root.style.setProperty('--main-leash', button.dataset.color);
        if (typeof applyToneState === 'function') applyToneState();
      });
    });

    document.querySelectorAll('#accentSwatches .swatch').forEach(button => {
      button.addEventListener('click', () => {
        document.querySelectorAll('#accentSwatches .swatch').forEach(b => b.classList.remove('is-active'));
        button.classList.add('is-active');
        root.style.setProperty('--accent', button.dataset.color);
        if (typeof applyToneState === 'function') applyToneState();
      });
    });

    

    document.querySelectorAll('#leashWidthOptions .width-option').forEach(button => {
      button.addEventListener('click', () => {
        document.querySelectorAll('#leashWidthOptions .width-option').forEach(b => b.classList.remove('is-active'));
        button.classList.add('is-active');

        const width = button.dataset.width;
        root.dataset.leashWidth = width;

        const widthScaleMap = {
          "0.5": 0.66,
          "0.625": 0.83,
          "0.75": 1,
          "1": 1.28
        };

        root.style.setProperty('--leash-width-scale', widthScaleMap[width] || 1);
        updateClipWidthScale();
        updateHardwareAvailability();
        updateHardwareFromDropdown();
        updateCheckoutSummary();
      });
    });




    const clipStyleSelect = document.getElementById('clipStyleSelect');
    const boltSnapPreview = document.getElementById('boltSnapPreview');
    const triggerSnapPreview = document.getElementById('triggerSnapPreview');
    const carabinerPreview = document.getElementById('carabinerPreview');
    const hardwareSelect = document.getElementById('hardwareSelect');
    const leashLengthSelect = document.getElementById('leashLengthSelect');
    const grippyOptions = Array.from(document.querySelectorAll('#grippyOptions .width-option'));
    const oRingOptions = Array.from(document.querySelectorAll('#oRingOptions .width-option'));
    const handleORingVisual = document.getElementById('handleORingVisual');
    const twoToneOptions = Array.from(document.querySelectorAll('#twoToneOptions .width-option'));
    const threeToneOptions = Array.from(document.querySelectorAll('#threeToneOptions .width-option'));
    const accentColorField = document.getElementById('accentColorField');
    const handleColorField = document.getElementById('handleColorField');
    const handleSwatches = Array.from(document.querySelectorAll('#handleSwatches .swatch'));
    const accentGripSwatches = Array.from(document.querySelectorAll('#accentGripSwatches .swatch'));
    const handleGripSwatches = Array.from(document.querySelectorAll('#handleGripSwatches .swatch'));
    const accentSwatchesContainer = document.getElementById('accentSwatches');
    const accentGripSwatchesContainer = document.getElementById('accentGripSwatches');
    const handleSwatchesContainer = document.getElementById('handleSwatches');
    const handleGripSwatchesContainer = document.getElementById('handleGripSwatches');
    const mainLeashColorLabel = document.getElementById('mainLeashColorLabel');
    const twoToneGroup = document.getElementById('twoToneGroup');
    const threeToneGroup = document.getElementById('threeToneGroup');
    const gripTextureOptions = Array.from(document.querySelectorAll('#gripTextureOptions .width-option'));
    const gripColorSwatches = Array.from(document.querySelectorAll('#gripColorSwatches .swatch'));
    const grippyDetails = document.getElementById('grippyDetails');
    const grippyHelper = document.getElementById('grippyHelper');
    const mainLeashColorField = document.getElementById('mainLeashColorField');
    const leashLengthHelper = document.getElementById('leashLengthHelper');
    const optionUpchargeSummary = document.getElementById('optionUpchargeSummary');
    const saveLeashDesignButton = document.getElementById('saveLeashDesignButton');
    const saveDesignStatus = document.getElementById('saveDesignStatus');
    const addToCartButton = document.getElementById('addToCartButton');
    const cartStatus = document.getElementById('cartStatus');
    const mappedProductNotice = document.getElementById('mappedProductNotice');

    const leashProductData = (() => {
      const node = document.getElementById('PupsUpLeashProductData');
      if (!node) return {};
      try {
        return JSON.parse(node.textContent || '{}');
      } catch (error) {
        return {};
      }
    })();

    const addonChargeVariants = (() => {
      const node = document.getElementById('PupsUpLeashAddonVariantData');
      if (!node) return [];
      try {
        const parsed = JSON.parse(node.textContent || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    })();

    function formatMoneyFromCents(cents) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }

    function cleanOptionLabel(text) {
      return String(text || '').replace(/\s*\(\+\$[\d.]+\)\s*$/, '').trim();
    }

    function getBasePriceCents() {
      return Number(leashProductData.price || root.dataset.leashPrice || 0);
    }

    function getSelectedVariantId() {
      return Number(leashProductData.variant_id || root.dataset.leashVariant || 0) || null;
    }

    function isGrippySelected() {
      return document.querySelector('#grippyOptions .width-option.is-active')?.dataset.grippy === 'yes';
    }

    function getEffectiveWidth() {
      if (isGrippySelected()) return '0.625';
      return document.querySelector('#leashWidthOptions .width-option.is-active')?.dataset.width || '0.75';
    }

    function getSelectedWidthLabel() {
      if (isGrippySelected()) return '5/8"';
      const active = document.querySelector('#leashWidthOptions .width-option.is-active');
      return active?.textContent?.trim() || '3/4"';
    }

    function getSelectedGripTexture() {
      return document.querySelector('#gripTextureOptions .width-option.is-active')?.dataset.gripTexture || 'Pebble Grip';
    }

    function getSelectedGripColorName() {
      return document.querySelector('#gripColorSwatches .swatch.is-active')?.dataset.colorName || 'Teal';
    }

    function isORingSelected() {
      return document.querySelector('#oRingOptions .width-option.is-active')?.dataset.oRing === 'yes';
    }


    function applyORingState() {
      const enabled = isORingSelected();

      // Yes always uses the approved handle O-ring design.
      handleORingVisual?.classList.toggle('is-hidden', !enabled);

      root.dataset.oRing = enabled ? 'Yes' : 'No';
      updateCheckoutSummary();
    }

    function isPebbleGripSelected() {
      return isGrippySelected() && getSelectedGripTexture() === 'Pebble Grip';
    }

    function isSuperGripSelected() {
      return isGrippySelected() && getSelectedGripTexture() === 'Super Grip';
    }

    function isTwoToneSelected() {
      return document.querySelector('#twoToneOptions .width-option.is-active')?.dataset.twoTone === 'yes';
    }

    function isThreeToneSelected() {
      return document.querySelector('#threeToneOptions .width-option.is-active')?.dataset.threeTone === 'yes';
    }

    function getSelectedHandleColorName() {
      if (isPebbleGripSelected()) {
        return document.querySelector('#handleGripSwatches .swatch.is-active')?.dataset.colorName || 'Teal';
      }
      return document.querySelector('#handleSwatches .swatch.is-active')?.dataset.colorName || '';
    }

    function getCurrentMainColorHex() {
      if (isGrippySelected()) {
        return document.querySelector('#gripColorSwatches .swatch.is-active')?.dataset.color || '#4199A0';
      }
      return document.querySelector('#mainSwatches .swatch.is-active')?.dataset.color || '#4DFA47';
    }

    function getSelectedMainColorName() {
      if (isGrippySelected()) return getSelectedGripColorName();
      return document.querySelector('#mainSwatches .swatch.is-active')?.dataset.colorName || '';
    }

    function getSelectedAccentColorName() {
      if (isPebbleGripSelected()) {
        return document.querySelector('#accentGripSwatches .swatch.is-active')?.dataset.colorName || 'Teal';
      }
      return document.querySelector('#accentSwatches .swatch.is-active')?.dataset.colorName || '';
    }

    function getHardwareUpchargeCents() {
      return Number(hardwareSelect?.selectedOptions?.[0]?.dataset.upcharge || 0);
    }

    function getHardwareLabel() {
      return cleanOptionLabel(hardwareSelect?.selectedOptions?.[0]?.textContent || 'Silver');
    }

    function getLengthUpchargeCents() {
      const feet = Number(leashLengthSelect?.value || 0);
      return feet > 2 ? (feet - 2) * 100 : 0;
    }

    function getLengthLabel() {
      const option = leashLengthSelect?.selectedOptions?.[0];
      return option?.value ? `${option.value} FT` : '';
    }

    function getLeashBaseAdjustmentCents() {
      // Shopify product base is $15.00. These adjustments create the real 2 FT starting price.
      if (isSuperGripSelected()) return 500;  // $20
      if (isPebbleGripSelected()) return 400; // $19

      const width = getEffectiveWidth();
      if (width === '0.5') return 100;  // $16
      if (width === '0.75') return 200; // $17
      if (width === '1') return 300;    // $18
      return 100;
    }

    function getLeashStartingPriceCents() {
      return getBasePriceCents() + getLeashBaseAdjustmentCents();
    }

    function getORingUpchargeCents() {
      return isORingSelected() ? 100 : 0;
    }

    function getClipStyleUpchargeCents() {
      return Number(clipStyleSelect?.selectedOptions?.[0]?.dataset.upcharge || 0);
    }


    function updateClipWidthScale() {
      const layer = document.getElementById('clipWidthScaleLayer');
      if (!layer) return;

      const width = getEffectiveWidth();

      // 1/2" is the tuned baseline. Hardware grows with leash width.
      const clipScaleMap = {
        "0.5": 1.00,
        "0.625": 1.12,
        "0.75": 1.24,
        "1": 1.42
      };

      const scale = clipScaleMap[width] || 1;

      // Keep oversized hardware inside the preview frame without shrinking
      // or moving the entire leash preview.
      const clipYOffsetMap = {
        "0.5": 0,
        "0.625": 7,
        "0.75": 15,
        "1": 32
      };
      const yOffset = clipYOffsetMap[width] || 0;

      layer.setAttribute(
        'transform',
        `translate(89 ${200 + yOffset}) scale(${scale}) translate(-89 -200)`
      );
      root.dataset.clipWidthScale = String(scale);
    
      const triggerCorrection = document.getElementById('triggerSnapCorrection');
      if (triggerCorrection) {
        triggerCorrection.setAttribute(
          'transform',
          width === "0.75"
            ? 'translate(88 120) scale(0.95) translate(-88 -120)'
            : ''
        );
      }

      const boltWidthCorrection = document.getElementById('boltSnapWidthCorrection');
      if (boltWidthCorrection) {
        const enlargeBolt = width === "0.75" || width === "1";
        boltWidthCorrection.setAttribute(
          'transform',
          enlargeBolt
            ? 'translate(88 120) scale(1.05) translate(-88 -120) translate(0 -9)'
            : ''
        );
      }

      const oRingScaleLayer = document.getElementById('oRingWidthScaleLayer');
      const oRingVisual = document.getElementById('handleORingVisual');
      if (oRingVisual) {
        if (width === "0.75") {
          oRingVisual.setAttribute('clip-path', 'url(#oRingThreeQuarterHandleEdgeClip)');
        } else {
          oRingVisual.removeAttribute('clip-path');
        }
      }
      if (oRingScaleLayer) {
        const oRingScaleMap = {
          "0.5": 0.78,
          "0.625": 0.90,
          "0.75": 1.00,
          "1": 1.18
        };

        const oRingScale = oRingScaleMap[width] || 1;

        // Keep the O-ring locked to its original approved position on the
        // right side of the handle while only changing its size.
        const oRingXOffset = width === "0.5" ? -8 : 0;

        if (width === "0.5") {
          // Keep the current approved 1/2" ring exactly as-is.
          const baseCenterX = 187;
          const baseWidth = 20.52;
          const widenedScaleX = (baseWidth + 4) / baseWidth;
          const rightEdgeX = baseCenterX + (baseWidth / 2);

          oRingScaleLayer.setAttribute(
            'transform',
            `translate(${rightEdgeX} 313) scale(${widenedScaleX} 1) translate(${-rightEdgeX} -313) translate(${baseCenterX} 313) scale(${oRingScale}) translate(-191 -313)`
          );
        } else if (width === "0.75") {
          // 3/4" only: keep the CURRENT LEFT EDGE fixed and add another
          // 5px of width ONLY toward the right.
          // Current ring width is base + existing 5px widening.
          const threeQuarterBaseWidth = 26.31;
          const currentThreeQuarterWidth = threeQuarterBaseWidth + 5;
          const rightOnlyExtraWidth = 5;
          const rightOnlyScaleX =
            (currentThreeQuarterWidth + rightOnlyExtraWidth) / currentThreeQuarterWidth;

          // Current center after the approved +8px move is 199.
          // Anchor the extra stretch on the current LEFT edge.
          const currentThreeQuarterCenterX = 199;
          const currentThreeQuarterLeftEdge =
            currentThreeQuarterCenterX - (currentThreeQuarterWidth / 2);

          const existingThreeQuarterScaleX =
            currentThreeQuarterWidth / threeQuarterBaseWidth;

          // Current approved 3/4" ring, plus:
          // - move the entire ring UP 2px
          // - widen another 2px ONLY toward the RIGHT
          const currentFinalThreeQuarterWidth =
            currentThreeQuarterWidth + rightOnlyExtraWidth;
          const extraRightOnlyWidth = 4;
          const extraRightOnlyScaleX =
            (currentFinalThreeQuarterWidth + extraRightOnlyWidth) /
            currentFinalThreeQuarterWidth;

          // After the approved movement, the current left edge is the
          // original stretch anchor + 11px. Anchor this extra stretch there
          // so the LEFT edge does not move.
          const approvedThreeQuarterLeftEdge =
            currentThreeQuarterLeftEdge + 11;

          oRingScaleLayer.setAttribute(
            'transform',
            `translate(3 -2) translate(${approvedThreeQuarterLeftEdge} 313) scale(${extraRightOnlyScaleX} 1) translate(${-approvedThreeQuarterLeftEdge} -313) translate(11 0) translate(${currentThreeQuarterLeftEdge} 313) scale(${rightOnlyScaleX} 1) translate(${-currentThreeQuarterLeftEdge} -313) translate(8 0) translate(191 313) scale(${existingThreeQuarterScaleX} 1) translate(-191 -313) translate(191 313) scale(${oRingScale}) translate(-191 -313)`
          );
        } else if (width === "1") {
          // 1" only: keep the current 10% enlargement, rotate slightly
          // clockwise, and move the whole O-ring another 6px right.
          const oneInchExtraScale = 1.15;
          const oneInchRotation = 8;
          oRingScaleLayer.setAttribute(
            'transform',
            `translate(16 2) translate(191 313) rotate(${oneInchRotation}) scale(${oRingScale * oneInchExtraScale}) translate(-191 -313)`
          );
        } else {
          oRingScaleLayer.setAttribute(
            'transform',
            `translate(191 313) scale(${oRingScale}) translate(-191 -313)`
          );
        }
      }

    }

    function updateClipStylePreview() {
      const clipValue = clipStyleSelect?.value || 'bolt';

      if (clipValue === 'trigger') {
        root.dataset.clipPreview = 'trigger';
      } else if (clipValue === 'carabiner') {
        root.dataset.clipPreview = 'carabiner';
      } else if (clipValue === 'frog') {
        root.dataset.clipPreview = 'frog';
      } else {
        root.dataset.clipPreview = 'bolt';
      }

      updateClipWidthScale();
      updateHardwareAvailability();
      updateHardwareFromDropdown();
    }

    function getClipStyleLabel() {
      return cleanOptionLabel(clipStyleSelect?.selectedOptions?.[0]?.textContent || 'Bolt Snap');
    }

    function getSelectedAddonCharges() {
      const charges = [];

      const baseAdjustmentCents = getLeashBaseAdjustmentCents();
      if (baseAdjustmentCents > 0) {
        let label = `${getSelectedWidthLabel()} Leash Base`;
        if (isPebbleGripSelected()) label = 'Pebble Grip Base';
        if (isSuperGripSelected()) label = 'Super Grip Base';

        charges.push({
          label,
          cents: baseAdjustmentCents
        });
      }

      const lengthCents = getLengthUpchargeCents();
      if (lengthCents > 0) {
        charges.push({
          label: `${getLengthLabel()} Leash Length`,
          cents: lengthCents
        });
      }

      const toneCents = isThreeToneSelected() ? 200 : (isTwoToneSelected() ? 100 : 0);
      if (toneCents > 0) {
        charges.push({
          label: isThreeToneSelected() ? 'Three-Tone' : 'Two-Tone',
          cents: toneCents
        });
      }

      const oRingCents = getORingUpchargeCents();
      if (oRingCents > 0) {
        charges.push({
          label: 'Add O-Ring',
          cents: oRingCents
        });
      }

      const clipCents = getClipStyleUpchargeCents();
      if (clipCents > 0) {
        charges.push({
          label: `${getClipStyleLabel()} Upgrade`,
          cents: clipCents
        });
      }

      const hardwareCents = getHardwareUpchargeCents();
      if (hardwareCents > 0) {
        charges.push({
          label: `${getHardwareLabel()} Hardware`,
          cents: hardwareCents
        });
      }

      return charges;
    }

    function getTotalAddonUpchargeCents() {
      return getSelectedAddonCharges()
        .reduce((sum, charge) => sum + Number(charge.cents || 0), 0);
    }

    function getEstimatedTotalCents() {
      return getBasePriceCents() + getTotalAddonUpchargeCents();
    }

    function buildAddonSummary() {
      const charges = getSelectedAddonCharges();
      return charges.length
        ? charges.map(charge => `${charge.label} +${formatMoneyFromCents(charge.cents)}`).join(', ')
        : 'None';
    }

    function updateCheckoutSummary() {
      const addonTotal = getTotalAddonUpchargeCents();
      const total = getEstimatedTotalCents();

      if (optionUpchargeSummary) {
        optionUpchargeSummary.textContent =
          `Total Add-ons Charge: +${formatMoneyFromCents(addonTotal)}`;
      }

      if (addToCartButton) {
        const label = root.dataset.addToCartLabel || 'Add Design to Cart';
        addToCartButton.textContent = `${label} • ${formatMoneyFromCents(total)}`;
      }
    }

    function applyGripPaletteAndTexture() {
      const pebble = isPebbleGripSelected();
      const superGrip = isSuperGripSelected();

      // The pebble effect is just a transparent overlay, so the selected
      // BioThane color remains the true underlying color.
      root.classList.toggle('is-pebble-grip', pebble);
      root.classList.toggle('is-super-grip', superGrip);

      // Pebble Grip two/three-tone choices must use the same 9 grip colors.
      accentSwatchesContainer?.classList.toggle('is-hidden', pebble);
      accentGripSwatchesContainer?.classList.toggle('is-hidden', !pebble);
      handleSwatchesContainer?.classList.toggle('is-hidden', pebble);
      handleGripSwatchesContainer?.classList.toggle('is-hidden', !pebble);

      // ONLY Super Grip hides tone controls. Pebble Grip explicitly shows them.
      twoToneGroup?.classList.toggle('is-hidden', superGrip);
      threeToneGroup?.classList.toggle('is-hidden', superGrip);
    }

    function applyToneState() {
      const superGrip = isSuperGripSelected();
      let twoTone = isTwoToneSelected();
      let threeTone = isThreeToneSelected();

      // Super Grip MUST be single-color.
      if (superGrip) {
        twoToneOptions.forEach(b => b.classList.remove('is-active'));
        threeToneOptions.forEach(b => b.classList.remove('is-active'));
        document.querySelector('#twoToneOptions [data-two-tone="no"]')?.classList.add('is-active');
        document.querySelector('#threeToneOptions [data-three-tone="no"]')?.classList.add('is-active');
        twoTone = false;
        threeTone = false;
        twoToneGroup?.classList.add('is-hidden');
        threeToneGroup?.classList.add('is-hidden');
      } else {
        twoToneGroup?.classList.remove('is-hidden');
        threeToneGroup?.classList.remove('is-hidden');
      }

      // Three-Tone is its own mode. Two-Tone can visually remain NO.
      // Either mode needs Accent Color; only Three-Tone needs Handle Color.
      const showAccent = twoTone || threeTone;
      accentColorField?.classList.toggle('is-hidden', !showAccent);
      handleColorField?.classList.toggle('is-hidden', !threeTone);

      if (mainLeashColorLabel) {
        mainLeashColorLabel.textContent = showAccent ? 'Main Leash Color' : 'Leash Color';
      }

      const mainColor = getCurrentMainColorHex();
      const accentColor = isPebbleGripSelected()
        ? (document.querySelector('#accentGripSwatches .swatch.is-active')?.dataset.color || mainColor)
        : (document.querySelector('#accentSwatches .swatch.is-active')?.dataset.color || mainColor);
      const handleColor = isPebbleGripSelected()
        ? (document.querySelector('#handleGripSwatches .swatch.is-active')?.dataset.color || mainColor)
        : (document.querySelector('#handleSwatches .swatch.is-active')?.dataset.color || mainColor);

      root.dataset.twoTone = twoTone ? 'Yes' : 'No';
      root.dataset.threeTone = threeTone ? 'Yes' : 'No';

      // Single-color.
      if (!twoTone && !threeTone) {
        root.style.setProperty('--main-leash', mainColor);
        root.style.setProperty('--accent', mainColor);
        root.style.setProperty('--handle-color', mainColor);
      }
      // Two-tone: accent strip + handle share the Accent Color.
      else if (twoTone) {
        root.style.setProperty('--main-leash', mainColor);
        root.style.setProperty('--accent', accentColor);
        root.style.setProperty('--handle-color', accentColor);
      }
      // Three-tone: main body, accent strip, and handle are all independent.
      else {
        root.style.setProperty('--main-leash', mainColor);
        root.style.setProperty('--accent', accentColor);
        root.style.setProperty('--handle-color', handleColor);
      }

      updateCheckoutSummary();
    }

    function updateHardwareAvailability() {
      if (!hardwareSelect) return;

      const effectiveWidth = getEffectiveWidth();
      const clipValue = clipStyleSelect?.value || 'bolt';

      Array.from(hardwareSelect.options).forEach(option => {
        const widthRules = String(option.dataset.widths || '')
          .split(',')
          .map(v => v.trim())
          .filter(Boolean);

        const allowedByWidth =
          widthRules.length === 0 || widthRules.includes(effectiveWidth);

        let allowedByClip = true;

        if (clipValue === 'frog') {
          allowedByClip = option.value === 'black';
        } else if (clipValue === 'carabiner') {
          allowedByClip = option.value === 'silver' || option.value === 'black';
        }

        const allowed = allowedByWidth && allowedByClip;
        option.disabled = !allowed;
        option.hidden = !allowed;
      });

      const selected = hardwareSelect.selectedOptions?.[0];

      if (!selected || selected.disabled) {
        if (clipValue === 'frog') {
          hardwareSelect.value = 'black';
        } else {
          hardwareSelect.value = 'silver';
        }
      }
    }

    function applyGrippyState() {
      const grippy = isGrippySelected();
      const standardWidthButtons = Array.from(document.querySelectorAll('#leashWidthOptions .width-option'));

      if (grippy) {
        grippyDetails?.classList.remove('is-hidden');
        mainLeashColorField?.classList.add('is-hidden');
        standardWidthButtons.forEach(button => button.disabled = true);
        root.dataset.leashWidth = '0.625';
        root.dataset.grippy = 'Yes';
        root.dataset.gripTexture = getSelectedGripTexture();
        root.dataset.gripColor = getSelectedGripColorName();
        root.style.setProperty('--leash-width-scale', 0.83);
        const gripColor = document.querySelector('#gripColorSwatches .swatch.is-active');
        if (gripColor) root.style.setProperty('--main-leash', gripColor.dataset.color);
        if (grippyHelper) grippyHelper.textContent = `5/8" ${getSelectedGripTexture()} selected.`;
      } else {
        grippyDetails?.classList.add('is-hidden');
        mainLeashColorField?.classList.remove('is-hidden');
        standardWidthButtons.forEach(button => button.disabled = false);
        const activeWidth = document.querySelector('#leashWidthOptions .width-option.is-active');
        const width = activeWidth?.dataset.width || '0.75';
        const scales = { "0.5": 0.66, "0.75": 1, "1": 1.28 };
        root.dataset.leashWidth = width;
        root.dataset.grippy = 'No';
        root.dataset.gripTexture = '';
        root.dataset.gripColor = '';
        root.style.setProperty('--leash-width-scale', scales[width] || 1);
        if (grippyHelper) grippyHelper.textContent = 'Choose Yes for a 5/8" grippy leash.';
      }

      updateHardwareAvailability();
      updateHardwareFromDropdown();
      applyGripPaletteAndTexture();
      applyToneState();
      updateClipWidthScale();
      updateCheckoutSummary();
    }

    function updateHardwareFromDropdown() {
      if (!hardwareSelect) return;
      const option = hardwareSelect.selectedOptions?.[0];
      root.style.setProperty('--hardware', option?.dataset.fill || 'url(#hardwareSilver)');
      root.dataset.hardware = getHardwareLabel();
      root.dataset.hardwareUpcharge = getHardwareUpchargeCents();
      updateCheckoutSummary();
    }

    function updateLengthSelection() {
      if (!leashLengthSelect) return;

      const option = leashLengthSelect.selectedOptions?.[0];
      const length = option?.value || '';
      const lengthCents = getLengthUpchargeCents();

      root.dataset.leashLength = length;
      root.dataset.leashLengthUpcharge = lengthCents / 100;

      if (leashLengthHelper) {
        if (!length) {
          leashLengthHelper.textContent = 'Select the finished leash length.';
        } else if (Number(length) === 2) {
          leashLengthHelper.textContent =
            `2 FT selected • starting price ${formatMoneyFromCents(getLeashStartingPriceCents())}`;
        } else {
          leashLengthHelper.textContent =
            `${length} FT selected • +${formatMoneyFromCents(lengthCents)} for extra length`;
        }
      }

      updateCheckoutSummary();
    }

    function updateMappedProductNotice() {
      if (!mappedProductNotice) return;

      if (getSelectedVariantId()) {
        mappedProductNotice.textContent = '';
        mappedProductNotice.classList.remove('is-error');
        return;
      }

      mappedProductNotice.textContent =
        'Choose the Leash Shopify product in the Leash Studio theme settings before publishing.';
      mappedProductNotice.classList.add('is-error');
    }

    function buildLineItemProperties() {
      const hardwareCents = getHardwareUpchargeCents();

      return {
        'Builder product': leashProductData.product_title || root.dataset.leashProduct || 'Leash',
        'Leash width': getSelectedWidthLabel(),
        'Leash length': getLengthLabel(),
        'Grippy': isGrippySelected() ? 'Yes' : 'No',
        'Grip texture': isGrippySelected() ? getSelectedGripTexture() : 'N/A',
        'Super Grip single-color': isSuperGripSelected() ? 'Required' : 'N/A',
        'Two-Tone': isTwoToneSelected() ? 'Yes (+$1.00)' : 'No',
        'Three-Tone': isThreeToneSelected() ? 'Yes (+$2.00)' : 'No',
        'Add O-Ring': isORingSelected() ? 'Yes (+$1.00)' : 'No',
        'Clip style': getClipStyleUpchargeCents() > 0
          ? `${getClipStyleLabel()} (+${formatMoneyFromCents(getClipStyleUpchargeCents())})`
          : getClipStyleLabel(),
        '2 FT starting price': formatMoneyFromCents(getLeashStartingPriceCents()),
        'Two-tone': isTwoToneSelected() ? 'Yes' : 'No',
        'Three-tone': isThreeToneSelected() ? 'Yes' : 'No',
        'Main leash color': getSelectedMainColorName(),
        'Accent color': (isTwoToneSelected() || isThreeToneSelected()) ? getSelectedAccentColorName() : 'Same as main',
        'Handle color': isThreeToneSelected()
          ? getSelectedHandleColorName()
          : (isTwoToneSelected() ? getSelectedAccentColorName() : getSelectedMainColorName()),
        'Hardware': hardwareCents > 0
          ? `${getHardwareLabel()} (+${formatMoneyFromCents(hardwareCents)})`
          : getHardwareLabel(),
        'Selected paid add-ons': buildAddonSummary(),
        'Total option upcharge': formatMoneyFromCents(getTotalAddonUpchargeCents()),
        'Total leash price': formatMoneyFromCents(getEstimatedTotalCents())
      };
    }

    function availableAddonDenominations() {
      return addonChargeVariants
        .filter(v => Number(v?.price || 0) > 0)
        .filter(v => v.available !== false)
        .sort((a, b) => Number(b.price) - Number(a.price));
    }

    function splitChargeIntoVariants(targetCents) {
      let remaining = Number(targetCents || 0);
      const variants = availableAddonDenominations();
      const chosen = [];

      for (const variant of variants) {
        const value = Number(variant.price || 0);
        while (value > 0 && remaining >= value) {
          chosen.push(variant);
          remaining -= value;
        }
      }

      return remaining === 0 ? chosen : null;
    }

    async function addStudioDesignToCart() {
      if (!addToCartButton) return;

      if (!getLengthLabel()) {
        if (cartStatus) {
          cartStatus.textContent = 'Please choose a leash length first.';
          cartStatus.className = 'cart-status is-error';
        }
        leashLengthSelect?.focus();
        return;
      }

      const variantId = getSelectedVariantId();

      if (!variantId) {
        if (cartStatus) {
          cartStatus.textContent =
            'Choose the Leash Shopify product in the Leash Studio theme settings first.';
          cartStatus.className = 'cart-status is-error';
        }
        return;
      }

      const originalLabel = addToCartButton.textContent;
      addToCartButton.disabled = true;
      addToCartButton.textContent = 'Adding…';

      try {
        const rootPath =
          (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        const baseProperties = buildLineItemProperties();
        const selectedCharges = getSelectedAddonCharges();

        const designKey =
          `pupsup-leash-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

        const cartItems = [{
          id: variantId,
          quantity: 1,
          properties: {
            ...baseProperties,
            _PupsUpDesignKey: designKey
          }
        }];

        if (selectedCharges.length > 0) {
          if (!addonChargeVariants.length) {
            throw new Error(
              'Paid add-ons are selected, but the "Add-on Charge product" has not been selected in the Leash Studio theme settings.'
            );
          }

          for (const charge of selectedCharges) {
            const pieces = splitChargeIntoVariants(charge.cents);

            if (!pieces || !pieces.length) {
              throw new Error(
                `The Add-on Charge product cannot make ${formatMoneyFromCents(charge.cents)} for: ${charge.label}.`
              );
            }

            pieces.forEach((variant, index) => {
              cartItems.push({
                id: Number(variant.id),
                quantity: 1,
                properties: {
                  _PupsUpDesignKey: designKey,
                  'For': `${getSelectedWidthLabel()} Leash`,
                  'Charge': `${charge.label} (+${formatMoneyFromCents(charge.cents)})`,
                  'Charge part': pieces.length > 1
                    ? `${index + 1} of ${pieces.length} • ${formatMoneyFromCents(variant.price)}`
                    : formatMoneyFromCents(variant.price),
                  'Required Leash add-ons': buildAddonSummary()
                }
              });
            });
          }
        }

        const response = await fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: cartItems })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Could not add this leash design to cart.');
        }

        if (cartStatus) {
          cartStatus.textContent = 'Added to cart ✓';
          cartStatus.className = 'cart-status is-success';
        }

        if (root.dataset.redirectToCart !== 'false') {
          window.location.href = root.dataset.cartUrl || (rootPath + 'cart');
        } else {
          addToCartButton.disabled = false;
          updateCheckoutSummary();
        }
      } catch (error) {
        if (cartStatus) {
          cartStatus.textContent = error.message || 'Could not add this leash design to cart.';
          cartStatus.className = 'cart-status is-error';
        }

        addToCartButton.disabled = false;
        addToCartButton.textContent = originalLabel;
      }
    }

    twoToneOptions.forEach(button => {
      button.addEventListener('click', () => {
        if (isSuperGripSelected()) return;

        twoToneOptions.forEach(b => b.classList.remove('is-active'));
        button.classList.add('is-active');

        // Two-Tone YES and Three-Tone YES are separate modes.
        if (button.dataset.twoTone === 'yes') {
          threeToneOptions.forEach(b => b.classList.remove('is-active'));
          document.querySelector('#threeToneOptions [data-three-tone="no"]')?.classList.add('is-active');
        }

        applyToneState();
        updateCheckoutSummary();
      });
    });

    threeToneOptions.forEach(button => {
      button.addEventListener('click', () => {
        if (isSuperGripSelected()) return;

        threeToneOptions.forEach(b => b.classList.remove('is-active'));
        button.classList.add('is-active');

        // Three-Tone YES keeps Two-Tone visually set to NO,
        // while still showing Main + Accent + Handle color options.
        if (button.dataset.threeTone === 'yes') {
          twoToneOptions.forEach(b => b.classList.remove('is-active'));
          document.querySelector('#twoToneOptions [data-two-tone="no"]')?.classList.add('is-active');
        }

        applyToneState();
        updateCheckoutSummary();
      });
    });

    accentGripSwatches.forEach(button => {
      button.addEventListener('click', () => {
        accentGripSwatches.forEach(b => b.classList.remove('is-active'));
        button.classList.add('is-active');
        applyToneState();
      });
    });

    handleGripSwatches.forEach(button => {
      button.addEventListener('click', () => {
        handleGripSwatches.forEach(b => b.classList.remove('is-active'));
        button.classList.add('is-active');
        applyToneState();
      });
    });

    handleSwatches.forEach(button => {
      button.addEventListener('click', () => {
        handleSwatches.forEach(b => b.classList.remove('is-active'));
        button.classList.add('is-active');
        applyToneState();
      });
    });

    oRingOptions.forEach(button => {
      button.addEventListener('click', () => {
        oRingOptions.forEach(b => b.classList.remove('is-active'));
        button.classList.add('is-active');
        applyORingState();
      });
    });


    grippyOptions.forEach(button => {
      button.addEventListener('click', () => {
        grippyOptions.forEach(b => b.classList.remove('is-active'));
        button.classList.add('is-active');
        applyGrippyState();
      });
    });

    gripTextureOptions.forEach(button => {
      button.addEventListener('click', () => {
        gripTextureOptions.forEach(b => b.classList.remove('is-active'));
        button.classList.add('is-active');
        root.dataset.gripTexture = getSelectedGripTexture();
        if (isGrippySelected() && grippyHelper) grippyHelper.textContent = `5/8" ${getSelectedGripTexture()} selected.`;
        applyGripPaletteAndTexture();
        applyToneState();
        applyGripPaletteAndTexture();
        updateCheckoutSummary();
      });
    });

    gripColorSwatches.forEach(button => {
      button.addEventListener('click', () => {
        gripColorSwatches.forEach(b => b.classList.remove('is-active'));
        button.classList.add('is-active');
        root.dataset.gripColor = button.dataset.colorName || '';
        if (isGrippySelected()) root.style.setProperty('--main-leash', button.dataset.color);
        applyToneState();
        updateCheckoutSummary();
      });
    });

    if (hardwareSelect) {
      hardwareSelect.addEventListener('change', updateHardwareFromDropdown);
    }

    if (clipStyleSelect) {
      clipStyleSelect.addEventListener('change', () => {
        root.dataset.clipStyle = getClipStyleLabel();
        updateClipStylePreview();
        updateCheckoutSummary();
      });
    }

    if (leashLengthSelect) {
      leashLengthSelect.addEventListener('change', updateLengthSelection);
    }

    document.querySelectorAll('#leashWidthOptions .width-option').forEach(button => {
      button.addEventListener('click', updateCheckoutSummary);
    });

    document.querySelectorAll('#mainSwatches .swatch, #accentSwatches .swatch, #handleSwatches .swatch, #gripColorSwatches .swatch, #accentGripSwatches .swatch, #handleGripSwatches .swatch').forEach(button => {
      button.addEventListener('click', updateCheckoutSummary);
    });


    function resolveSvgCssVariables(svgMarkup) {
      const rootStyles = getComputedStyle(root);
      return svgMarkup.replace(
        /var\((--[A-Za-z0-9-_]+)(?:,\s*([^)]+))?\)/g,
        (_match, variableName, fallback) => {
          const value = rootStyles.getPropertyValue(variableName).trim();
          return value || (fallback ? fallback.trim() : '');
        }
      );
    }

    function buildSavedLeashFilename() {
      const length = leashLengthSelect?.value
        ? `${leashLengthSelect.value}ft`
        : 'custom-length';

      const width = isGrippySelected()
        ? getSelectedGripTexture().toLowerCase().replace(/\s+/g, '-')
        : getSelectedWidthLabel()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '');

      const mainColor = getSelectedMainColorName()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');

      return `pups-up-leash-${length}-${width || 'width'}-${mainColor || 'design'}.jpg`;
    }

    async function saveLeashDesignAsJpeg() {
      const svg = root.querySelector('.leash-svg');
      if (!svg) throw new Error('Leash preview SVG not found.');

      const clone = svg.cloneNode(true);
      clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      clone.setAttribute('width', '1040');
      clone.setAttribute('height', '1360');

      // Inline the live visual state so the downloaded JPEG matches the preview.
      const sourceElements = [svg, ...svg.querySelectorAll('*')];
      const cloneElements = [clone, ...clone.querySelectorAll('*')];

      sourceElements.forEach((sourceEl, index) => {
        const cloneEl = cloneElements[index];
        if (!cloneEl) return;

        const computed = getComputedStyle(sourceEl);
        [
          'fill',
          'stroke',
          'stroke-width',
          'stroke-linecap',
          'stroke-linejoin',
          'opacity',
          'display',
          'visibility',
          'paint-order'
        ].forEach(property => {
          const value = computed.getPropertyValue(property);
          if (value) cloneEl.style.setProperty(property, value);
        });
      });

      let svgMarkup = new XMLSerializer().serializeToString(clone);
      svgMarkup = resolveSvgCssVariables(svgMarkup);

      const blob = new Blob([svgMarkup], { type: 'image/svg+xml;charset=utf-8' });
      const objectUrl = URL.createObjectURL(blob);

      try {
        const image = new Image();

        await new Promise((resolve, reject) => {
          image.onload = resolve;
          image.onerror = () => reject(new Error('Could not render the leash preview.'));
          image.src = objectUrl;
        });

        const canvas = document.createElement('canvas');
        canvas.width = 1040;
        canvas.height = 1360;

        const ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('Canvas is unavailable.');

        ctx.fillStyle = '#f7f8f8';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

        const jpegUrl = canvas.toDataURL('image/jpeg', 0.94);

        const link = document.createElement('a');
        link.href = jpegUrl;
        link.download = buildSavedLeashFilename();
        document.body.appendChild(link);
        link.click();
        link.remove();
      } finally {
        URL.revokeObjectURL(objectUrl);
      }
    }

    if (saveLeashDesignButton) {
      saveLeashDesignButton.addEventListener('click', async () => {
        if (saveLeashDesignButton.disabled) return;

        const originalLabel = saveLeashDesignButton.textContent;
        saveLeashDesignButton.disabled = true;
        saveLeashDesignButton.textContent = 'Saving...';
        if (saveDesignStatus) saveDesignStatus.textContent = '';

        try {
          await saveLeashDesignAsJpeg();
          if (saveDesignStatus) saveDesignStatus.textContent = 'JPEG saved!';
        } catch (error) {
          console.error(error);
          if (saveDesignStatus) {
            saveDesignStatus.textContent = 'Could not save the design. Please try again.';
          }
        } finally {
          saveLeashDesignButton.disabled = false;
          saveLeashDesignButton.textContent = originalLabel;

          window.setTimeout(() => {
            if (saveDesignStatus) saveDesignStatus.textContent = '';
          }, 3000);
        }
      });
    }

    if (addToCartButton) {
      addToCartButton.addEventListener('click', addStudioDesignToCart);
    }

    applyGrippyState();
    applyORingState();
    applyGripPaletteAndTexture();
    applyToneState();
    updateHardwareAvailability();
    updateHardwareFromDropdown();
    root.dataset.clipStyle = getClipStyleLabel();
    updateLengthSelection();
    updateMappedProductNotice();
    updateCheckoutSummary();


/* Pups Up default preview: Sage + 1/2" */
(function setPupsUpLeashDefaultPreview(){
  function applyDefaults(){
    const root = document.querySelector('#PupsUpLeashStudio, .pups-up-leash-studio');
    if (!root) return;

    const widthButtons = root.querySelectorAll('[data-width]');
    let half = null;
    widthButtons.forEach(btn => {
      const w = String(btn.dataset.width || '').trim();
      const isHalf = w === '0.5' || w === '1/2' || /1\/2/.test(btn.textContent || '');
      btn.classList.toggle('active', isHalf);
      btn.classList.toggle('is-active', isHalf);
      if (btn.hasAttribute('aria-pressed')) btn.setAttribute('aria-pressed', isHalf ? 'true' : 'false');
      if (isHalf) half = btn;
    });
    if (half) half.click();

    const sageCandidates = [...root.querySelectorAll('[data-color], [data-name], [data-color-name]')];
    const sage = sageCandidates.find(el =>
      String(el.dataset.color || '').toUpperCase() === '#A9BBA0' ||
      String(el.dataset.name || '').toLowerCase() === 'sage' ||
      String(el.dataset.colorName || '').toLowerCase() === 'sage'
    );
    if (sage) sage.click();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDefaults, { once:true });
  } else {
    applyDefaults();
  }
})();


  // Keep the Live Preview visible while scrolling the right-side controls.
  // Uses translateY instead of CSS position:sticky so Shopify theme overflow
  // wrappers cannot disable the behavior.
  (function initLeashPreviewScrollFollow(){
    const studio = document.getElementById('PupsUpLeashStudio');
    if (!studio) return;

    const builder = studio.querySelector('.builder');
    const preview = studio.querySelector('.preview-panel');
    if (!builder || !preview) return;

    const stickyTop = 16;
    let ticking = false;

    function updatePreviewFollow(){
      ticking = false;

      if (window.innerWidth <= 850) {
        preview.style.transform = '';
        return;
      }

      // Temporarily ignore the current visual transform when measuring the
      // builder's document position.
      const builderRect = builder.getBoundingClientRect();
      const builderTop = window.scrollY + builderRect.top;
      const builderHeight = builder.offsetHeight;
      const previewHeight = preview.offsetHeight;

      const wanted = window.scrollY + stickyTop - builderTop;
      const maxTravel = Math.max(0, builderHeight - previewHeight);
      const travel = Math.max(0, Math.min(wanted, maxTravel));

      preview.style.transform = `translateY(${travel}px)`;
    }

    function requestPreviewFollow(){
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updatePreviewFollow);
    }

    window.addEventListener('scroll', requestPreviewFollow, { passive: true });
    window.addEventListener('resize', requestPreviewFollow);
    window.addEventListener('load', requestPreviewFollow);
    requestPreviewFollow();
  })();
